import React from 'react';
import Drawer, { FooterSpacer } from '../../Drawer';
import Button from '../../Button';
import { TAG_KINDS, TAG_KIND_BLURBS, TAGS_WORDING as W, tagChooserNote } from '../../../domain/tags';
import { BRAND } from '../../../domain/brand';
import s from './tags.module.css';

// `Add Tag` on Students → Tags opens a chooser, not a form.
//
// MMS branches into "Group Tag" and "Instrument Tags", each with a sentence
// explaining the difference, and both doors lead to the same form: the choice
// decides what the record's Tag Type starts as, and the Edit drawer can change
// it afterwards. The chooser stays, rather than a Tag Type dropdown, because
// the difference is what a teacher is being asked about. The note below says
// what an instrument tag does in this app (`tagChooserNote` in
// src/domain/tags.js).

export default function AddTagChooser({ open, onClose, onChoose }) {
  const option = (kind, title) => (
    <button type="button" className={s.chooserOption} onClick={() => onChoose(kind)}>
      <div className={s.chooserTitle}>{title}</div>
      <div className={s.chooserBlurb}>{TAG_KIND_BLURBS[kind]}</div>
    </button>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={W.chooserTitle}
      width={520}
      footer={(
        <>
          <FooterSpacer />
          <Button variant="secondary" onClick={onClose}>{W.cancel}</Button>
        </>
      )}
    >
      <div className={s.chooser}>
        {option(TAG_KINDS.group, W.groupTag)}
        {option(TAG_KINDS.instrument, W.instrumentTag)}
        <div className={s.chooserNote}>
          {tagChooserNote(BRAND.name)}
        </div>
      </div>
    </Drawer>
  );
}
